import { render, staticRenderFns } from "./comment-control.vue?vue&type=template&id=5fa91dc2"
import script from "./comment-control.vue?vue&type=script&lang=js"
export * from "./comment-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports